/**
 * CompareRangeWarnings.jsx : avertissements de qualité des données dans la
 * plage d'analyse (mesures tronquées à la limite de chargement, couverture
 * insuffisante), textes calculés par analysisRangeText.qualityWarnings.
 */
import React from 'react';
import { semanticColors } from '../constants/semanticColors';

export default function CompareRangeWarnings({ lines, darkMode = false }) {
  if (!lines.length) return null;
  return (
    <div role="status" data-testid="compare-range-warnings"
      style={{ padding: '10px 14px', borderRadius: '8px', margin: '0 0 16px',
        fontSize: '13px', fontWeight: '500',
        background: darkMode ? 'transparent' : semanticColors.amberBg,
        border: `1px solid ${semanticColors.amberText}`,
        color: darkMode ? semanticColors.amberSolid : semanticColors.amberText }}>
      {lines.map(line => <p key={line} style={{ margin: '2px 0' }}>{line}</p>)}
    </div>
  );
}
